// https://github.com/aaronfagan/svg-credit-card-payment-icons

// React component imports
import AmexIcon from './AmexIcon'
import VisaIcon from './VisaIcon'
import DiscoverIcon from './DiscoverIcon'
import MastercardIcon from './MastercardIcon'
import MaestroIcon from './MaestroIcon'
import JCBIcon from './JCBIcon'
import GooglePayIcon from './GooglePayIcon'
import ApplePayIcon from './ApplePayIcon'
import DinersClubIcon from './DinersClubIcon'

export {
  AmexIcon,
  VisaIcon,
  DiscoverIcon,
  MastercardIcon,
  MaestroIcon,
  JCBIcon,
  GooglePayIcon,
  ApplePayIcon,
  DinersClubIcon,
}

export const cardBrandIconsMap = {
  VISA: <VisaIcon />,
  MC: <MastercardIcon />,
  DISC: <DiscoverIcon />,
  AMEX: <AmexIcon />,
  MAESTRO: <MaestroIcon />,
  JCB: <JCBIcon />,
  GOOGLEPAY: <GooglePayIcon />,
  APPLEPAY: <ApplePayIcon />,
  DINERSCLUB: <DinersClubIcon />,
}
